export const X_NINJA_USER_ID_HEADER = 'x-ninja-user-id';
export const X_NINJA_CONVERSATION_ID_HEADER = 'x-ninja-conversation-id';
export const X_NINJA_TASK_ID_HEADER = 'x-ninja-task-id';
export const X_NINJA_EVENT_ID_HEADER = 'x-ninja-event-id';
export const X_NINJA_BYPASS_USER_ACCESS_CHECK = 'BYPASS_USER_ACCESS_CHECK';

export const retryable_http_codes = [429, 500, 502, 503, 504];
